import template from './template.html';
import controller from './controller';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider, $urlRouterProvider){

	$stateProvider.state('main.panel.doorLocks', {
		url: '/doorLocks',
		template: template,
		controller: controller,
		controllerAs: 'vm'

	});

}








/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/doorLocks.component/routes.js
 **/